/* /src/components/auth/callback.jsx */
import React, { useContext, useEffect } from "react";
import { AppContext } from "../../providers/appProvider";
import Typography from "@material-ui/core/Typography";
import { useHistory } from 'react-router-dom';
import { consumeLoginRedirectPath } from "../../helpers/authRedirect";

import { bindActionCreators } from "redux";
import { connect, useDispatch } from 'react-redux';
import { actionCreators } from "../../store/NavItems";

const ADMIN_ROLE = "Administrator";
const COLLABORATION_REDIRECT_PATH = "/view/collaboration";

const getUserRoles = (user) => {
    const role = user?.profile?.role;

    if (Array.isArray(role)) {
        return role;
    }

    if (typeof role === "string" && role.length > 0) {
        return [role];
    }

    return [];
};

const isAdministrator = (user) => {
    return getUserRoles(user).includes(ADMIN_ROLE);
};

export const Callback = () => {
    const app = useContext(AppContext);
    const { UserManager, changeUser } = app;
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        let isMounted = true;

        UserManager.signinRedirectCallback()
            .then(user => {
                if (!isMounted) {
                    return;
                }

                if (!user) {
                    consumeLoginRedirectPath();
                    history.replace('/');
                    return;
                }

                if (!isAdministrator(user)) {
                    UserManager.removeUser()
                        .catch(error => {
                            console.log("removeUser error", error);
                        });

                    UserManager.clearStaleState();
                    sessionStorage.removeItem('regnumber');
                    consumeLoginRedirectPath();
                    changeUser(null);
                    dispatch(actionCreators.setAppUser(null));
                    history.replace(COLLABORATION_REDIRECT_PATH);
                    return;
                }

                changeUser(user);
                dispatch(actionCreators.setAppUser(user));

                if (user) {
                    const regnumber = user.profile.name;
                    sessionStorage.setItem('regnumber', regnumber);

                    dispatch(actionCreators.getCustomer());

                    const token = `${(user ? user.token_type : '')} ${(user ? user.access_token : '')}`;
                    const URL = '/api/v1.0/account/log/';
                    const headers = new Headers();
                    headers.append("Content-Type", "application/json");
                    headers.append("Accept", "application/json");
                    headers.append("Authorization", token);
                    fetch(URL, { method: "GET", headers: headers })
                        .then(response => {
                            console.log(response.status);
                        });
                }

                history.replace(consumeLoginRedirectPath());
            })
            .catch(error => {
                console.log(error);
                if (isMounted) {
                    history.replace('/');
                }
            });

        return () => {
            isMounted = false;
        };
    }, [UserManager, changeUser, dispatch, history]);

    return (
        <Typography>Loading user...</Typography>
    )    
};


export default connect(
    state => state.appLayout,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Callback)
